module.exports = __webpack_public_path__ + "static/media/Sanad2.b2b9a693.jpg";